import React from 'react';

export const MAX_CREDENTIAL_SEND_SELECTION = 100;

export const CREDENTIALS_SEND_WARNING = 'Seçilen hesapların şifreleri yenilenecek ve eski şifreleri geçersiz olacaktır. Yeni giriş bilgileri WhatsApp ile gönderilecektir. Devam etmek istiyor musunuz?';

export const getCredentialsSendErrorMessage = (error, fallback = 'Giriş bilgileri gönderilemedi.') => (
  error?.response?.data?.message || fallback
);

const firstCount = (source, keys, fallback = 0) => {
  const value = keys.map(key => source?.[key]).find(item => item !== undefined && item !== null);
  const count = Number(value);
  return Number.isFinite(count) ? count : fallback;
};

const renewedCount = (summary) => {
  const generic = firstCount(summary, ['yenilenen', 'yenilenen_sayisi', 'sifre_yenilenen'], Number.NaN);
  if (Number.isFinite(generic)) return generic;

  const teacherCount = firstCount(summary, ['sifresi_yenilenen_ogretmen'], Number.NaN);
  if (Number.isFinite(teacherCount)) return teacherCount;

  return firstCount(summary, ['sifresi_yenilenen_ogrenci'])
    + firstCount(summary, ['sifresi_yenilenen_veli']);
};

export const normalizeCredentialsSendResult = (responseData = {}) => {
  const nested = responseData?.data && typeof responseData.data === 'object' ? responseData.data : {};
  const summary = responseData?.ozet || nested?.ozet || {};
  const rawSkipped = responseData?.atlananlar || nested?.atlananlar || [];
  const skipped = Array.isArray(rawSkipped)
    ? rawSkipped.map(item => ({
        id: item?.id ?? item?.kayit_id ?? item?.ogrenci_id ?? item?.user_id ?? item?.ogretmen_id ?? '—',
        neden: item?.neden || 'Belirtilmedi',
      }))
    : [];

  return {
    message: responseData?.message || nested?.message || 'Giriş bilgileri gönderim kuyruğuna alındı.',
    summary: {
      renewed: renewedCount(summary),
      queued: firstCount(summary, ['kuyruga_alinan', 'kuyruga_alinan_sayisi', 'mesaj_kuyruga_alinan', 'kuyruga_alinan_mesaj']),
      skipped: firstCount(summary, ['atlanan', 'atlanan_sayisi'], skipped.length),
    },
    skipped,
  };
};

export default function CredentialsSendModals({ pendingIds, sending, result, onConfirm, onCancel, onResultClose }) {
  return (
    <>
      {pendingIds?.length > 0 && (
        <div className="modal-backdrop" onClick={() => !sending && onCancel()}>
          <div className="modal" role="alertdialog" aria-modal="true" aria-labelledby="credentials-send-title" style={{ maxWidth: 560 }} onClick={event => event.stopPropagation()}>
            <div className="modal-header">
              <div id="credentials-send-title" className="modal-title">⚠️ Giriş Bilgilerini Gönder</div>
              <button className="modal-close" onClick={onCancel} disabled={sending} aria-label="Kapat">✕</button>
            </div>
            <div style={{ padding: '8px 0' }}>
              <div style={{ padding: '14px 16px', borderRadius: 10, background: '#FEF3C7', border: '1px solid #FCD34D', color: '#92400E', lineHeight: 1.6, fontWeight: 650 }}>
                {CREDENTIALS_SEND_WARNING}
              </div>
              <div style={{ marginTop: 12, color: 'var(--text-muted)', fontSize: '0.82rem' }}>
                İşlem yapılacak hesap sayısı: <strong>{pendingIds.length}</strong>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20, flexWrap: 'wrap' }}>
              <button className="btn btn-outline" onClick={onCancel} disabled={sending}>Vazgeç</button>
              <button className="btn btn-primary" onClick={onConfirm} disabled={sending}>
                {sending ? 'Gönderim Kuyruğa Alınıyor…' : 'Evet, Şifreleri Yenile ve Gönder'}
              </button>
            </div>
          </div>
        </div>
      )}

      {result && (
        <div className="modal-backdrop" onClick={onResultClose}>
          <div className="modal" role="dialog" aria-modal="true" aria-labelledby="credentials-result-title" style={{ maxWidth: 620 }} onClick={event => event.stopPropagation()}>
            <div className="modal-header">
              <div id="credentials-result-title" className="modal-title">✅ Gönderim Sonucu</div>
              <button className="modal-close" onClick={onResultClose} aria-label="Kapat">✕</button>
            </div>
            <p style={{ color: 'var(--text-secondary)', lineHeight: 1.55, margin: '4px 0 18px' }}>{result.message}</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
              {[
                ['Yenilenen', result.summary.renewed, '#2563EB', '#EFF6FF'],
                ['Kuyruğa Alınan', result.summary.queued, '#059669', '#ECFDF5'],
                ['Atlanan', result.summary.skipped, '#D97706', '#FFFBEB'],
              ].map(([label, count, color, background]) => (
                <div key={label} style={{ padding: '14px 10px', textAlign: 'center', borderRadius: 10, color, background }}>
                  <div style={{ fontSize: '1.35rem', fontWeight: 900 }}>{count}</div>
                  <div style={{ marginTop: 3, fontSize: '0.75rem', fontWeight: 700 }}>{label}</div>
                </div>
              ))}
            </div>

            {result.skipped.length > 0 && (
              <div style={{ marginTop: 18 }}>
                <div style={{ fontWeight: 800, marginBottom: 8 }}>Atlanan Kayıtlar</div>
                <div style={{ maxHeight: 240, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 10 }}>
                  {result.skipped.map((item, index) => (
                    <div key={`${item.id}-${index}`} style={{ display: 'grid', gridTemplateColumns: '100px 1fr', gap: 10, padding: '10px 12px', borderBottom: index < result.skipped.length - 1 ? '1px solid var(--border)' : 'none', fontSize: '0.82rem' }}>
                      <strong>ID: {item.id}</strong>
                      <span style={{ color: 'var(--text-secondary)' }}>{item.neden}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
              <button className="btn btn-primary" onClick={onResultClose}>Tamam</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
